import React from 'react';
import withMainLayout from 'layouts/main';
import dynamic from 'next/dynamic';
import {createTranslator} from 'next-intl';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/pricing/hero';
import PlansSection from '@/content/pricing/plans-section';
import shared from '../messages/en/shared.json';
import pricing from '../messages/en/pricing.json';

// Content imports

const AiAgentAddon = dynamic(() => import('@/content/pricing/workable-ai-agent-addon'), {
  loading: () => null
});
const PlansFeatures = dynamic(() => import('@/content/pricing/plans-features'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const PricingPage = () => (
  <>
    <HeroSection />
    <PlansSection />
    <AiAgentAddon />
    <PlansFeatures />
    <PreFooter />
  </>
);

const seoMetas = props => {
  const seoT = createTranslator({locale: props.locale, messages: props.messages});
  return {
    title: seoT('pricing.seo.title'),
    description: seoT('pricing.seo.description'),
    canonical: seoT('pricing.seo.canonical')
  };
};

export default withMainLayout(PricingPage, seoMetas);

export const messagesForIntl = {shared, pricing};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}
